// Swiss public holidays · Kanton St. Gallen (Mels).
// Fixed-date holidays + Easter-based moveable feasts computed via the
// Meeus/Jones/Butcher Computus algorithm — so 2027, 2028, … are produced
// automatically without manual entry.
//
// Source: Kantonsverwaltung St. Gallen, Feiertagsverzeichnis.
// Half-day holidays (Heiligabend 24.12, Silvester 31.12) are intentionally
// not included — the office is normally reachable in the morning.
//
// To extend the catalog (e.g. add Maria Himmelfahrt for catholic districts
// or company-specific closures), simply push another entry into the array
// returned by getSGHolidays() — same shape: { date: Date, key: string }.

function easterSunday(year) {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(year, month - 1, day);
}

function addDays(d, n) {
  const x = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  x.setDate(x.getDate() + n);
  return x;
}

function ymd(d) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

const NAMES = {
  neujahr:       { de: "Neujahr",          fr: "Nouvel An",            it: "Capodanno",            en: "New Year's Day" },
  berchtoldstag: { de: "Berchtoldstag",    fr: "Saint-Berchtold",      it: "San Bertoldo",         en: "Berchtold Day" },
  karfreitag:    { de: "Karfreitag",       fr: "Vendredi saint",       it: "Venerdì Santo",        en: "Good Friday" },
  ostermontag:   { de: "Ostermontag",      fr: "Lundi de Pâques",      it: "Lunedì di Pasqua",     en: "Easter Monday" },
  auffahrt:      { de: "Auffahrt",         fr: "Ascension",            it: "Ascensione",           en: "Ascension Day" },
  pfingstmontag: { de: "Pfingstmontag",    fr: "Lundi de Pentecôte",   it: "Lunedì di Pentecoste", en: "Whit Monday" },
  bundesfeier:   { de: "Bundesfeiertag",   fr: "Fête nationale",       it: "Festa nazionale",      en: "Swiss National Day" },
  allerheiligen: { de: "Allerheiligen",    fr: "Toussaint",            it: "Ognissanti",           en: "All Saints' Day" },
  weihnachten:   { de: "Weihnachten",      fr: "Noël",                 it: "Natale",               en: "Christmas Day" },
  stephanstag:   { de: "Stephanstag",      fr: "Saint-Étienne",        it: "Santo Stefano",        en: "St. Stephen's Day" },
};

export function getSGHolidays(year) {
  const easter = easterSunday(year);
  return [
    { date: new Date(year, 0, 1),   key: "neujahr" },
    { date: new Date(year, 0, 2),   key: "berchtoldstag" },
    { date: addDays(easter, -2),    key: "karfreitag" },
    { date: addDays(easter, 1),     key: "ostermontag" },
    { date: addDays(easter, 39),    key: "auffahrt" },
    { date: addDays(easter, 50),    key: "pfingstmontag" },
    { date: new Date(year, 7, 1),   key: "bundesfeier" },
    { date: new Date(year, 10, 1),  key: "allerheiligen" },
    { date: new Date(year, 11, 25), key: "weihnachten" },
    { date: new Date(year, 11, 26), key: "stephanstag" },
  ];
}

export function findHoliday(date) {
  const list = getSGHolidays(date.getFullYear());
  const target = ymd(date);
  return list.find((h) => ymd(h.date) === target) || null;
}

export function holidayName(key, lang) {
  return (NAMES[key] && (NAMES[key][lang] || NAMES[key].de)) || "";
}
